module.exports = __webpack_public_path__ + "media/images/icons/phone_footer_icon-f4cc76e5d25d885311c9f3d436a065fd.svg";